export const english = {
  brandName: require("./logo.png"),
  background: require("./background.png"),
  logo: require("./logo.png"),
  trigger: require("./trigger.svg"),
  poweredby: require("./poweredby.png"),
  lottiejson: require("./lottie.json"),
  lowRating: require("./lowRating.png"),
  midRating: require("./midRating.png"),
  highRating: require("./highRating.png"),
  outerBackground: require("./outerBackground.jpg"),
  user: require("./user.png"),
  feedbackIcons: [
    require("./angry.png"),
    require("./confounded.png"),
    require("./neutralFace.png"),
    require("./slightlySmilingFace.png"),
    require("./heartEyes.png"),
  ],
}

export const usa = {
  brandName: require('./logo.png'),
  background: require('./background.png'),
  logo: require('./logo.png'),
  trigger: require('./trigger.svg'),
  poweredby: require('./poweredby.png'),
  lottiejson: require('./lottie.json'),
  lowRating: require('./lowRating.png'),
  midRating: require('./midRating.png'),
  highRating: require('./highRating.png'),
  outerBackground: require('./outerBackground.jpg'),
  user: require('./user.png'),
  feedbackIcons: [
    require('./angry.png'),
    require('./confounded.png'),
    require('./neutralFace.png'),
    require('./slightlySmilingFace.png'),
    require('./heartEyes.png'),
  ],
}

export const canada = {
  brandName: require("./logo.png"),
  background: require("./background.png"),
  logo: require("./logo.png"),
  trigger: require("./trigger.svg"),
  poweredby: require("./poweredby.png"),
  lottiejson: require("./lottie.json"),
  lowRating: require("./lowRating.png"),
  midRating: require("./midRating.png"),
  highRating: require("./highRating.png"),
  outerBackground: require("./outerBackground.jpg"),
  user: require("./user.png"),
  feedbackIcons: [
    require("./angry.png"),
    require("./confounded.png"),
    require("./neutralFace.png"),
    require("./slightlySmilingFace.png"),
    require("./heartEyes.png"),
  ],
}

export const italian = {
  brandName: require("./logo.png"),
  background: require("./background.png"),
  logo: require("./logo.png"),
  trigger: require("./trigger.svg"),
  poweredby: require("./poweredby.png"),
  lottiejson: require("./lottie.json"),
  lowRating: require("./lowRating.png"),
  midRating: require("./midRating.png"),
  highRating: require("./highRating.png"),
  outerBackground: require("./outerBackground.jpg"),
  user: require("./user.png"),
}

export const japenese = {
  brandName: require("./logo.png"),
  background: require("./background.png"),
  logo: require("./logo.png"),
  trigger: require("./trigger.svg"),
  poweredby: require("./poweredby.png"),
  lottiejson: require("./lottie.json"),
  lowRating: require("./lowRating.png"),
  midRating: require("./midRating.png"),
  highRating: require("./highRating.png"),
  outerBackground: require("./outerBackground.jpg"),
  user: require("./user.png"),
}

export const swedish = {
  brandName: require("./logo.png"),
  background: require("./background.png"),
  logo: require("./logo.png"),
  trigger: require("./trigger.svg"),
  poweredby: require("./poweredby.png"),
  lottiejson: require("./lottie.json"),
  lowRating: require("./lowRating.png"),
  midRating: require("./midRating.png"),
  highRating: require("./highRating.png"),
  outerBackground: require("./outerBackground.jpg"),
  user: require("./user.png"),
}

export const argentina_spanish = {
  brandName: require("./logo.png"),
  background: require("./background.png"),
  logo: require("./logo.png"),
  trigger: require("./trigger.svg"),
  poweredby: require("./poweredby.png"),
  lottiejson: require("./lottie.json"),
  lowRating: require("./lowRating.png"),
  midRating: require("./midRating.png"),
  highRating: require("./highRating.png"),
  outerBackground: require("./outerBackground.jpg"),
  user: require("./user.png"),
}

export const austria_german = {
  brandName: require("./logo.png"),
  background: require("./background.png"),
  logo: require("./logo.png"),
  trigger: require("./trigger.svg"),
  poweredby: require("./poweredby.png"),
  lottiejson: require("./lottie.json"),
  lowRating: require("./lowRating.png"),
  midRating: require("./midRating.png"),
  highRating: require("./highRating.png"),
  outerBackground: require("./outerBackground.jpg"),
  user: require("./user.png"),
}

export const belgium_french = {
  brandName: require("./logo.png"),
  background: require("./background.png"),
  logo: require("./logo.png"),
  trigger: require("./trigger.svg"),
  poweredby: require("./poweredby.png"),
  lottiejson: require("./lottie.json"),
  lowRating: require("./lowRating.png"),
  midRating: require("./midRating.png"),
  highRating: require("./highRating.png"),
  outerBackground: require("./outerBackground.jpg"),
  user: require("./user.png"),
}

export const belgium_dutch = {
  brandName: require("./logo.png"),
  background: require("./background.png"),
  logo: require("./logo.png"),
  trigger: require("./trigger.svg"),
  poweredby: require("./poweredby.png"),
  lottiejson: require("./lottie.json"),
  lowRating: require("./lowRating.png"),
  midRating: require("./midRating.png"),
  highRating: require("./highRating.png"),
  outerBackground: require("./outerBackground.jpg"),
  user: require("./user.png"),
}

export const switzerland_french = {
  brandName: require("./logo.png"),
  background: require("./background.png"),
  logo: require("./logo.png"),
  trigger: require("./trigger.svg"),
  poweredby: require("./poweredby.png"),
  lottiejson: require("./lottie.json"),
  lowRating: require("./lowRating.png"),
  midRating: require("./midRating.png"),
  highRating: require("./highRating.png"),
  outerBackground: require("./outerBackground.jpg"),
  user: require("./user.png"),
}

export const switzerland_german = {
  brandName: require("./logo.png"),
  background: require("./background.png"),
  logo: require("./logo.png"),
  trigger: require("./trigger.svg"),
  poweredby: require("./poweredby.png"),
  lottiejson: require("./lottie.json"),
  lowRating: require("./lowRating.png"),
  midRating: require("./midRating.png"),
  highRating: require("./highRating.png"),
  outerBackground: require("./outerBackground.jpg"),
  user: require("./user.png"),
}

export const switzerland_italian = {
  brandName: require("./logo.png"),
  background: require("./background.png"),
  logo: require("./logo.png"),
  trigger: require("./trigger.svg"),
  poweredby: require("./poweredby.png"),
  lottiejson: require("./lottie.json"),
  lowRating: require("./lowRating.png"),
  midRating: require("./midRating.png"),
  highRating: require("./highRating.png"),
  outerBackground: require("./outerBackground.jpg"),
  user: require("./user.png"),
}

export const chile_spanish = {
  brandName: require("./logo.png"),
  background: require("./background.png"),
  logo: require("./logo.png"),
  trigger: require("./trigger.svg"),
  poweredby: require("./poweredby.png"),
  lottiejson: require("./lottie.json"),
  lowRating: require("./lowRating.png"),
  midRating: require("./midRating.png"),
  highRating: require("./highRating.png"),
  outerBackground: require("./outerBackground.jpg"),
  user: require("./user.png"),
}

export const colombia_spanish = {
  brandName: require("./logo.png"),
  background: require("./background.png"),
  logo: require("./logo.png"),
  trigger: require("./trigger.svg"),
  poweredby: require("./poweredby.png"),
  lottiejson: require("./lottie.json"),
  lowRating: require("./lowRating.png"),
  midRating: require("./midRating.png"),
  highRating: require("./highRating.png"),
  outerBackground: require("./outerBackground.jpg"),
  user: require("./user.png"),
}

export const german = {
  brandName: require("./logo.png"),
  background: require("./background.png"),
  logo: require("./logo.png"),
  trigger: require("./trigger.svg"),
  poweredby: require("./poweredby.png"),
  lottiejson: require("./lottie.json"),
  lowRating: require("./lowRating.png"),
  midRating: require("./midRating.png"),
  highRating: require("./highRating.png"),
  outerBackground: require("./outerBackground.jpg"),
  user: require("./user.png"),
}

export const ecuador_spanish = {
  brandName: require("./logo.png"),
  background: require("./background.png"),
  logo: require("./logo.png"),
  trigger: require("./trigger.svg"),
  poweredby: require("./poweredby.png"),
  lottiejson: require("./lottie.json"),
  lowRating: require("./lowRating.png"),
  midRating: require("./midRating.png"),
  highRating: require("./highRating.png"),
  outerBackground: require("./outerBackground.jpg"),
  user: require("./user.png"),
}

export const spanish = {
  brandName: require("./logo.png"),
  background: require("./background.png"),
  logo: require("./logo.png"),
  trigger: require("./trigger.svg"),
  poweredby: require("./poweredby.png"),
  lottiejson: require("./lottie.json"),
  lowRating: require("./lowRating.png"),
  midRating: require("./midRating.png"),
  highRating: require("./highRating.png"),
  outerBackground: require("./outerBackground.jpg"),
  user: require("./user.png"),
}

export const finnish = {
  brandName: require("./logo.png"),
  background: require("./background.png"),
  logo: require("./logo.png"),
  trigger: require("./trigger.svg"),
  poweredby: require("./poweredby.png"),
  lottiejson: require("./lottie.json"),
  lowRating: require("./lowRating.png"),
  midRating: require("./midRating.png"),
  highRating: require("./highRating.png"),
  outerBackground: require("./outerBackground.jpg"),
  user: require("./user.png"),
}

export const french = {
  brandName: require("./logo.png"),
  background: require("./background.png"),
  logo: require("./logo.png"),
  trigger: require("./trigger.svg"),
  poweredby: require("./poweredby.png"),
  lottiejson: require("./lottie.json"),
  lowRating: require("./lowRating.png"),
  midRating: require("./midRating.png"),
  highRating: require("./highRating.png"),
  outerBackground: require("./outerBackground.jpg"),
  user: require("./user.png"),
}

export const kazakhstan_russian = {
  brandName: require("./logo.png"),
  background: require("./background.png"),
  logo: require("./logo.png"),
  trigger: require("./trigger.svg"),
  poweredby: require("./poweredby.png"),
  lottiejson: require("./lottie.json"),
  lowRating: require("./lowRating.png"),
  midRating: require("./midRating.png"),
  highRating: require("./highRating.png"),
  outerBackground: require("./outerBackground.jpg"),
  user: require("./user.png"),
}

export const mexico_spanish = {
  brandName: require("./logo.png"),
  background: require("./background.png"),
  logo: require("./logo.png"),
  trigger: require("./trigger.svg"),
  poweredby: require("./poweredby.png"),
  lottiejson: require("./lottie.json"),
  lowRating: require("./lowRating.png"),
  midRating: require("./midRating.png"),
  highRating: require("./highRating.png"),
  outerBackground: require("./outerBackground.jpg"),
  user: require("./user.png"),
}

export const dutch = {
  brandName: require("./logo.png"),
  background: require("./background.png"),
  logo: require("./logo.png"),
  trigger: require("./trigger.svg"),
  poweredby: require("./poweredby.png"),
  lottiejson: require("./lottie.json"),
  lowRating: require("./lowRating.png"),
  midRating: require("./midRating.png"),
  highRating: require("./highRating.png"),
  outerBackground: require("./outerBackground.jpg"),
  user: require("./user.png"),
}

export const panama_spanish = {
  brandName: require("./logo.png"),
  background: require("./background.png"),
  logo: require("./logo.png"),
  trigger: require("./trigger.svg"),
  poweredby: require("./poweredby.png"),
  lottiejson: require("./lottie.json"),
  lowRating: require("./lowRating.png"),
  midRating: require("./midRating.png"),
  highRating: require("./highRating.png"),
  outerBackground: require("./outerBackground.jpg"),
  user: require("./user.png"),
}

export const peru_spanish = {
  brandName: require("./logo.png"),
  background: require("./background.png"),
  logo: require("./logo.png"),
  trigger: require("./trigger.svg"),
  poweredby: require("./poweredby.png"),
  lottiejson: require("./lottie.json"),
  lowRating: require("./lowRating.png"),
  midRating: require("./midRating.png"),
  highRating: require("./highRating.png"),
  outerBackground: require("./outerBackground.jpg"),
  user: require("./user.png"),
}

export const russian = {
  brandName: require("./logo.png"),
  background: require("./background.png"),
  logo: require("./logo.png"),
  trigger: require("./trigger.svg"),
  poweredby: require("./poweredby.png"),
  lottiejson: require("./lottie.json"),
  lowRating: require("./lowRating.png"),
  midRating: require("./midRating.png"),
  highRating: require("./highRating.png"),
  outerBackground: require("./outerBackground.jpg"),
  user: require("./user.png"),
}

export const saudiarabia_arabic = {
  brandName: require("./logo.png"),
  background: require("./background.png"),
  logo: require("./logo.png"),
  trigger: require("./trigger.svg"),
  poweredby: require("./poweredby.png"),
  lottiejson: require("./lottie.json"),
  lowRating: require("./lowRating.png"),
  midRating: require("./midRating.png"),
  highRating: require("./highRating.png"),
  outerBackground: require("./outerBackground.jpg"),
  user: require("./user.png"),
}

export const turkish = {
  brandName: require("./logo.png"),
  background: require("./background.png"),
  logo: require("./logo.png"),
  trigger: require("./trigger.svg"),
  poweredby: require("./poweredby.png"),
  lottiejson: require("./lottie.json"),
  lowRating: require("./lowRating.png"),
  midRating: require("./midRating.png"),
  highRating: require("./highRating.png"),
  outerBackground: require("./outerBackground.jpg"),
  user: require("./user.png"),
}

export const uruguay_spanish = {
  brandName: require("./logo.png"),
  background: require("./background.png"),
  logo: require("./logo.png"),
  trigger: require("./trigger.svg"),
  poweredby: require("./poweredby.png"),
  lottiejson: require("./lottie.json"),
  lowRating: require("./lowRating.png"),
  midRating: require("./midRating.png"),
  highRating: require("./highRating.png"),
  outerBackground: require("./outerBackground.jpg"),
  user: require("./user.png"),
}

export const brazil = {
  brandName: require("./logo.png"),
  background: require("./background.png"),
  logo: require("./logo.png"),
  trigger: require("./trigger.svg"),
  poweredby: require("./poweredby.png"),
  lottiejson: require("./lottie.json"),
  lowRating: require("./lowRating.png"),
  midRating: require("./midRating.png"),
  highRating: require("./highRating.png"),
  outerBackground: require("./outerBackground.jpg"),
  user: require("./user.png"),
}

export const south_korea = {
  brandName: require("./logo.png"),
  background: require("./background.png"),
  logo: require("./logo.png"),
  trigger: require("./trigger.svg"),
  poweredby: require("./poweredby.png"),
  lottiejson: require("./lottie.json"),
  lowRating: require("./lowRating.png"),
  midRating: require("./midRating.png"),
  highRating: require("./highRating.png"),
  outerBackground: require("./outerBackground.jpg"),
  user: require("./user.png"),
}

export const poland = {
  brandName: require("./logo.png"),
  background: require("./background.png"),
  logo: require("./logo.png"),
  trigger: require("./trigger.svg"),
  poweredby: require("./poweredby.png"),
  lottiejson: require("./lottie.json"),
  lowRating: require("./lowRating.png"),
  midRating: require("./midRating.png"),
  highRating: require("./highRating.png"),
  outerBackground: require("./outerBackground.jpg"),
  user: require("./user.png"),
}
export const portugal = {
  brandName: require("./logo.png"),
  background: require("./background.png"),
  logo: require("./logo.png"),
  trigger: require("./trigger.svg"),
  poweredby: require("./poweredby.png"),
  lottiejson: require("./lottie.json"),
  lowRating: require("./lowRating.png"),
  midRating: require("./midRating.png"),
  highRating: require("./highRating.png"),
  outerBackground: require("./outerBackground.jpg"),
  user: require("./user.png"),
}

export const czech_republic = {
  brandName: require("./logo.png"),
  background: require("./background.png"),
  logo: require("./logo.png"),
  trigger: require("./trigger.svg"),
  poweredby: require("./poweredby.png"),
  lottiejson: require("./lottie.json"),
  lowRating: require("./lowRating.png"),
  midRating: require("./midRating.png"),
  highRating: require("./highRating.png"),
  outerBackground: require("./outerBackground.jpg"),
  user: require("./user.png"),
}

export const slovakia = {
  brandName: require("./logo.png"),
  background: require("./background.png"),
  logo: require("./logo.png"),
  trigger: require("./trigger.svg"),
  poweredby: require("./poweredby.png"),
  lottiejson: require("./lottie.json"),
  lowRating: require("./lowRating.png"),
  midRating: require("./midRating.png"),
  highRating: require("./highRating.png"),
  outerBackground: require("./outerBackground.jpg"),
  user: require("./user.png"),
}

export const romania = {
  brandName: require("./logo.png"),
  background: require("./background.png"),
  logo: require("./logo.png"),
  trigger: require("./trigger.svg"),
  poweredby: require("./poweredby.png"),
  lottiejson: require("./lottie.json"),
  lowRating: require("./lowRating.png"),
  midRating: require("./midRating.png"),
  highRating: require("./highRating.png"),
  outerBackground: require("./outerBackground.jpg"),
  user: require("./user.png"),
  feedbackIcons: [
    require("./angry.png"),
    require("./confounded.png"),
    require("./neutralFace.png"),
    require("./slightlySmilingFace.png"),
    require("./heartEyes.png"),
  ],
}

export const notification_sound = require("./notification.mp3")
